module.exports = __webpack_public_path__ + "static/media/ic-quality-work.d4503cae.svg";